<fn-modal-header class="modal-header-{{ type }}">
  <h5 class="modal-title text-truncate pr-25">
    <i [class]="dialogData.titleClass"></i>{{ dialogData.title | fnTranslate }}
  </h5>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close(false)">
    <i class="fn-global-times"></i>
  </button>
</fn-modal-header>
<mat-dialog-content>
  <h3 [innerHTML]="dialogData.content | fnTranslate" class="alert-msg-{{ type }}" cdkFocusInitial></h3>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row">
    <div class="col-12 text-right">
      <button class="btn btn-primary btn-round mr-5" (click)="close(true)">
        {{'YES' | fnTranslate}}
      </button>
      <button class="btn btn-danger btn-round" (click)="close(false)">
        {{'NO' | fnTranslate}}
      </button>
    </div>
  </div>
</mat-dialog-actions>
